// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"3c527724","513":"cb1dcb71","703":"13bb82b7","787":"8ff43c28"}[chunkId] + ".chunk.js";
};